<scitis-app-global-page-header [pageTitle]="'Trigger action'">
  <ng-template #filterElement>
    <button (click)="onAddTriggerQuery()" class="btn btn-primary">
      <span class="fa-solid fa-plus"></span>
      <span translate>New trigger action</span>
    </button>
  </ng-template>

</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name">
              <span translate>Name</span>
            </th>

            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="triggerActionType">
              <span translate>Type</span>
            </th>

            <th class="text-end" scope="col">
              <span translate>Functions</span>
            </th>
          </tr>
        </thead>
        <tbody>

          @for (trigger of triggerQueriesList; track trigger) {
            <tr>
              <td>
                <b>
                  <ngb-highlight [result]="trigger.name" [term]="''"></ngb-highlight>
                </b>
              </td>
              <td>
                <span [ngClass]="getBadgeClass(trigger.triggerActionType)"
                  class="badge badge-pill">
                  <ngb-highlight [result]="trigger.triggerActionType" [term]="''"></ngb-highlight>
                </span>
              </td>
              <td class="text-end">
                <scitis-admin-trigger-query-action
                  (triggerQueryDeleteEvent)="onDeleteEvent($event)"
                  (triggerQueryUpdatedEvent)="onTriggerQueryUpdatedEvent($event)"
                  [userRole]="userRole"
                  [machineId]="machineId"
                  [trigger]="getTrigger(trigger)">
                </scitis-admin-trigger-query-action>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
